/***********************************
  Menu Module
************************************/

Quad.FAQ = ( function() {


  // PRIVATE VARS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~


  // PRIVATE METHODS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  function _init() {

    $('.plus-minus').click(function(){

      var answer = $(this).parent().siblings( '.answer' );

      $(this).toggleClass( 'active' );

      $( answer ).slideToggle(150);

    });

    $( '#faq-form' ).submit( function( e ) {
      e.preventDefault();
    });

    $( '.clear-faq' ).hide();

    $( '.clear-faq' ).click( function() {
      $( '#faq-search' ).val( '' );
      $( this ).hide();
    });

    if ( $( 'body' ).hasClass( 'page-template-faq' )) {
      var options = { valueNames: [ 'answer', 'question' ]};
      var faq = new List( 'faq', options );
    }

    $( '.no-faq-results' ).hide();

    $( '#faq-form' ).submit( function() {
      $( '.clear-faq' ).show();
      var searchString = $( '#faq-search' ).val();
      faq.search( searchString );
      $( 'ul.list li' ).length === 0 ? $( '.no-faq-results' ).show() : $( '.no-faq-results' ).hide();
      loadMoreHide();
    });

    $( '#faq-form' ).keypress( function( event ) {
      var keycode = ( event.keyCode ? event.keyCode : event.which );
      if ( keycode == '13' ) {
        event.preventDefault();
        $( '.clear-faq' ).show();
        var searchString = $( '#faq-search' ).val();
        faq.search( searchString );
        $( 'ul.list li' ).length === 0 ? $( '.no-faq-results' ).show() : $( '.no-faq-results' ).hide();
        loadMoreHide();
      }

    });

    var pagination = 11;

    function loadMoreHide() {
      pagination = 11;
      $( 'ul.list li' ).each( function( index ) {
        index >= 12 ? $( this ).hide() : $( this ).show();
      });
      hideButton();
    }

    loadMoreHide();

    $( '.faq-loadmore button' ).click( function() {
      pagination += 12;
      $( 'ul.list li' ).each( function( index ) {
        index > pagination ? $( this ).hide() : $( this ).show();
      });
      hideButton();
    });

    function hideButton() {
      pagination >= $( 'ul.list li' ).length ? $( '.faq-loadmore button' ).hide() : $( '.faq-loadmore button' ).show();
    }

}


  // PUBLIC METHODS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  return {

    init: _init

  };

})();
